import CubeIcon from "../icons/CubeIcon";
import { filter, flexAlign, flexJustify, opacity } from "./functions";

export default function ShapeLayer ({layer}) {

  return <>
    <div
      className='absolute-full'
      draggable="false"
      style={{
        userSelect:     'none',
        background:     layer.color ?? '#333',
        display:        'flex',
        alignItems:     flexAlign(layer),
        justifyContent: flexJustify(layer),
        filter:         filter(layer),
        opacity:        opacity(layer),
        borderRadius:   layer.metadata.shape === 'circle' ? '50%' : layer.metadata.rounding ?? 0,
      }}
    >
      <div
        className='absolute-full flex flex-row'
        style={{
          position:   'absolute',
          lineHeight: 'initial',
          color:      layer.color ?? '#111111B3',
        }}
      >
        {layer.metadata.shape === 'circle' && <span style={{transform: 'scale(1.3)'}}><CubeIcon solid/></span>}
        {layer.metadata.shape === 'square' && <span style={{transform: 'scale(1.3)'}}><CubeIcon solid/></span>}
      </div>
    </div>
  </>
}

